import request from 'lib/helpers/requestApi';
import {
  TCheckDynamicCatalogDataRequest,
  TCheckDynamicCatalogDataResult,
  TGetObjectionNextStepData,
  TGetObjectionNextStepProps,
  TGetReportData,
  TGetReportProps,
  TGetReportSettingsData,
  TGetReportSettingsProps,
  TGetReportsListData,
} from './types';

/** Получение списка отчетов */
export const getReportsListAPI = request<TGetReportsListData[]>({
  method: 'reportBuilder.getReportsList',
});

/** Возврат данных для следующей ступени фильтра по объектам */
export const getObjectionNextStepAPI = request<
  TGetObjectionNextStepData,
  TGetObjectionNextStepProps
>({
  method: 'reportBuilder.getObjectionNextStep',
});

/** Вывод всех настроек (группировок, фильтров, стаститик filds полей) для конкретного отчета */
export const getReportSettingsAPI = request<
  TGetReportSettingsData,
  TGetReportSettingsProps
>({
  method: 'reportBuilder.getReportSettings',
});

/** Получение списка отчетов */
export const checkDynamicCatalogDataAPI = request<
  TCheckDynamicCatalogDataResult,
  TCheckDynamicCatalogDataRequest
>({
  method: 'reportBuilder.checkDynamicCatalogData',
});

/** Получение отчета по фильтрам */
export const getReportAPI = request<TGetReportData, TGetReportProps>({
  method: 'reportBuilder.getReport',
});
